import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const DetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
  background-color: ${({ theme }) => theme.palette[200]};
  border-radius: 8px;
`;

export const DetailsRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const DetailsLabel = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette[700]};
  text-transform: uppercase;
`;

export const DetailsValue = styled.span`
  font-size: 14px;
  color: ${({ theme }) => theme.palette[900]};
  word-break: break-word;
`;
